import { render, staticRenderFns } from "./RosePie.vue?vue&type=template&id=51b36c55&scoped=true&"
import script from "./RosePie.vue?vue&type=script&lang=js&"
export * from "./RosePie.vue?vue&type=script&lang=js&"
import style0 from "./RosePie.vue?vue&type=style&index=0&id=51b36c55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b36c55",
  null
  
)

export default component.exports